<template>
  <tr
    class="cabinet__tbody-row"
    :class="{
      'cabinet__tbody-row--need-answer' : isNeedAnswer
    }"
  >
    <td style="width: 19%">
      {{ idFormatted }}
    </td>
    <td style="width: 19%">
      {{ date }}
    </td>
    <td style="width: 19%">
      {{ lotNumber }}
    </td>
    <td style="width: 19%">
      {{ lotName }}
    </td>
    <td style="width: 19%">
      {{ status }}
    </td>
    <td>
      <router-link
        :to="{ name: 'ClarificationRequest', params: { id: id } }"
        class="tooltip__list-item-img tooltip__list-item-img--show show-contract"
      />
    </td>
  </tr>
</template>

<script>

import { dateFormat } from '@/utils/helpers';

export default {
  name: 'ClarificationListTableItem',
  components: {},
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    id() {
      return this.item.id;
    },
    idFormatted() {
      return this.item.id.toString().padStart(10, '0');
    },
    status() {
      return this.item.status;
    },
    date() {
      return dateFormat(this.item.createdAt);
    },
    lotNumber() {
      return this.item.lotNumber;
    },
    lotName() {
      return this.item.lotName;
    },
    isNeedAnswer() {
      return this.item?.commentFlag === true;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.show-contract {
  color: transparent;
  display: block;
  content: '';
  margin: 0 5px;
}
.cabinet__tbody-row--need-answer td,
.cabinet__tbody tr:nth-child(odd).cabinet__tbody-row--need-answer td{
  background-color: #EAF4DA;
}
</style>
